import React, { FC } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Project } from '@brg/api';
import { ProjectDesignerName } from '../../../components/projectDesignerName';
import { computeDesigner } from '../../../helpers/computeData';
import { CreateLinkTo } from '../../../constants/linkTo';
import type { ApplicationThemeT } from '../../../themes';
import { bURL } from '../../../../core';

const DesignerLink = styled(Link)<{ h: string }>`
    color: ${(p) => p.theme.tags.textColor} !important;
    cursor: pointer;

    &:hover {
        text-decoration: none;
        color: ${(p) => p.h} !important;
    }
`;

type PropsT = {
    project?: Project;
    theme: ApplicationThemeT;
};

export const PSAuthor: FC<PropsT> = ({ project, theme }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <FlexBox align="center">
        {project && <FInter.TextFlex align="center" color={theme.projectView.categoryText}>
        <DesignerLink
          h={theme.projectView.titleColor}
          to={`/${bURL.saveVariablesToURIComponent({ category: project.categoryID })}`}
        >
          {project.category.name}
        </DesignerLink>
        &nbsp;{t('by')}&nbsp;
      </FInter.TextFlex>}

      <FInter.Text color={theme.projectView.authorText}>
        <ProjectDesignerName
          className="other"
          onSelected={(id) => history.push(CreateLinkTo.designer(id))}
    // @ts-ignore
          value={[project.author].concat(project.coAuthors).map(computeDesigner)}
        />
      </FInter.Text>
    </FlexBox>
  );
};
import React, { FC } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Project } from '@brg/api';
import { ProjectDesignerName } from '../../../components/projectDesignerName';
import { computeDesigner } from '../../../helpers/computeData';
import { CreateLinkTo } from '../../../constants/linkTo';
import type { ApplicationThemeT } from '../../../themes';
import { bURL } from '../../../../core';

const DesignerLink = styled(Link)<{ h: string }>`
    color: ${(p) => p.theme.tags.textColor} !important;
    cursor: pointer;

    &:hover {
        text-decoration: none;
        color: ${(p) => p.h} !important;
    }
`;

type PropsT = {
    project?: Project;
    theme: ApplicationThemeT;
};

export const PSAuthor: FC<PropsT> = ({ project, theme }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <FlexBox align="center">
        {project && <FInter.TextFlex align="center" color={theme.projectView.categoryText}>
        <DesignerLink
          h={theme.projectView.titleColor}
          to={`/${bURL.saveVariablesToURIComponent({ category: project.categoryID })}`}
        >
          {project.category.name}
        </DesignerLink>
        &nbsp;{t('by')}&nbsp;
      </FInter.TextFlex>}

      <FInter.Text color={theme.projectView.authorText}>
        <ProjectDesignerName
          className="other"
          onSelected={(id) => history.push(CreateLinkTo.designer(id))}
    // @ts-ignore
          value={[project.author].concat(project.coAuthors).map(computeDesigner)}
        />
      </FInter.Text>
    </FlexBox>
  );
};
